import { IDmChuyenNganh } from "../../model/respone/category/IDmChuyenNganh";
import { apiClient } from "../apiClient";
export const CHUYEN_NGANH_ENDPOINT = "chuyen-nganh";
export const chuyenNganhApi = {
  SelectAll: () => apiClient.get(`${CHUYEN_NGANH_ENDPOINT}`),
  Insert: (payload: IDmChuyenNganh) =>
    apiClient.post(`${CHUYEN_NGANH_ENDPOINT}`, payload),
  Update: (payload: IDmChuyenNganh) =>
    apiClient.put(`${CHUYEN_NGANH_ENDPOINT}`, payload),
  Delete: (id: number) => apiClient.delete(`${CHUYEN_NGANH_ENDPOINT}/${id}`),
};
